export default __webpack_public_path__ + "static/media/mTop_3_p1.a434f68f.jpeg";